import { render, staticRenderFns } from "./SliderRange.vue?vue&type=template&id=28b3c367&"
import script from "./SliderRange.vue?vue&type=script&lang=js&"
export * from "./SliderRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports